module.exports = __webpack_public_path__ + "h5/img/assemble.5556ee86.jpg";